export { default as PartnerList } from './PartnerList';
export { default as PartnerDetails } from './PartnerDetails';
export { default as AddPartner } from './AddPartner';